import { RouteRecordRaw } from "vue-router";

import start from "@/views/start.vue";

import notFound from "@/views/notFound.vue";
import organisationNotFound from "@/views/organisationNotFound.vue";
import PreRegView from "@/views/PreRegView.vue";
import RegistrationForm from "@/views/RegistrationForm.vue";
import RegistrationFormStep1 from "@/views/RegistrationFormStep1.vue";
import RegistrationFormStep2 from "@/views/RegistrationFormStep2.vue";
import RegistrationFormSummary from "@/views/RegistrationFormSummary.vue";
import RegistrationFormConfirm from "@/views/RegistrationFormConfirm.vue";
import OrgDetailView from "@/views/OrgDetailView.vue";
import OrgAgreement from "@/views/OrgAgreement.vue";
import OrgAgreementContacts from "@/views/OrgAgreementContacts.vue";
import OrgAgreementConfirmAgreement from "@/views/OrgAgreementConfirmAgreement.vue";
import OrgAgreementConfirmPub from "@/views/OrgAgreementConfirmPub.vue";
import OrgAgreementConfirmSummary from "@/views/OrgAgreementConfirmSummary.vue";
import OrgUserAdmin from "@/views/OrgUserAdmin.vue";
import OrgAgreementIntro from "@/views/OrgAgreementIntro.vue";
import { useOrganisationStore } from "@/stores/organisation";
import { nextTick, watch } from "vue";


export const appRoutes: RouteRecordRaw[] = [
  {
    name: "start",
    component: start,
    path: "/"
  },
  {
    name: "PreRegView",
    component: PreRegView,
    path: "/registrering-intro"
  },
  {
    name: "RegistrationForm",
    component: RegistrationForm,
    path: "/registrering",
    children: [
      {
        name: "RegistrationFormStep1",
        component: RegistrationFormStep1,
        path: "steg-1"
      },
      {
        name: "RegistrationFormStep2",
        component: RegistrationFormStep2,
        path: "steg-2"
      },
      {
        name: "RegistrationFormSummary",
        component: RegistrationFormSummary,
        path: "steg-3"
      },
      {
        name: "RegistrationFormConfirm",
        component: RegistrationFormConfirm,
        path: "tack"
      }
    ]
  },
  {
    name: "OrgDetailView",
    component: OrgDetailView,
    path: "/organisation/:orgId",
    beforeEnter: async(_to, _from, next) => {
      const store = useOrganisationStore();
      if (store.$state.loaded) {
        next();
      } else{
        const stopWatching = watch(
            () => store.$state.loaded,
            (loaded) => {
              if (loaded) {
                stopWatching();
                nextTick().then(() => next());
              }
            }
          );
      }
    },
  }
  ,
  {
    name: "OrgAgreement",
    component: OrgAgreement,
    path: "/organisation/:orgId/avtal"
  },
  {
    name: "OrgAgreementMode",
    component: OrgAgreement,
    path: "/organisation/:orgId/avtal/:mode"
  },
  {
    name: "OrgAgreementIntro",
    component: OrgAgreementIntro,
    path: "/organisation/:orgId/avtal/intro/"
  },
  {
    name: "OrgAgreementContacts",
    component: OrgAgreementContacts,
    path: "/organisation/:orgId/avtal/kontakt/"
  },
  {
    name: "OrgAgreementConfirmStep1",
    component: OrgAgreementConfirmAgreement,
    path: "/organisation/:orgId/avtal/bekrafta/1"
  },
  {
    name: "OrgAgreementConfirmPub",
    component: OrgAgreementConfirmPub,
    path: "/organisation/:orgId/avtal/bekrafta/2"
  },
  {
    name: "OrgAgreementConfirmSummary",
    component: OrgAgreementConfirmSummary,
    path: "/organisation/:orgId/avtal/bekrafta/summering"
  },
  {
    name: "OrgUserAdmin",
    component: OrgUserAdmin,
    path: "/organisation/:orgId/anvandare/:userId?"
  },
  {
    name: "notFound",
    component: notFound,
    path: "/:pathMatch(.*)/:returnDepth?",
    props: true
    },
    {
        name: 'organisationNotFound',
        component: organisationNotFound,
        path: '/organisation/:orgId',
        props: true
    },
];